// Nomes das areas: iguais em pt e en por decisao de produto (AB#86893). Glossario em apps/web/AGENTS.md.
const navigation = {
  dashboard: "Pulse",
  knowledge: "Brain",
  agents: "Flows",
  jobs: "Jobs",
  skills: "Skills",
  playground: "Chat",
  database: "Banco de Dados",
  integrations: "Tools",
  dataSources: "Fontes de Dados",
  profile: "Perfil",
  settings: "Configurações",
  generalSettings: "Configurações Gerais",
  workspaceSettings: "Configurações do Workspace",
  selectWorkspace: "Selecione o Workspace",
  emptyWorkspacesMessage: "Cadastre um Workspace para ver as opções disponíveis",
  selectOrganization: "Selecionar organização",
  orgHint: {
    title: "Você entrou em {{organization}}",
    message: "Alterne de organização aqui.",
  },
  platformView: "SUPERADMIN",
  organizationView: "Visão da organização",
  personalView: "Minha visão",
  memory: "Memória",
  backToOrganization: "Voltar para organização",
  superadminOnlyTitle: "Área exclusiva da Visão Superadmin",
  superadminOnlyDescription: "Esta área só está disponível quando nenhuma organização está selecionada.",
  backToPlatform: "Voltar para Visão Superadmin",
  goToDashboard: "Ir para o Dashboard",
  account: "Conta",
  logout: "Sair",
  workspaceGroup: "Workspace",
  toggleSidebar: "Expandir/recolher menu"
} as const;

export default navigation;
